import React from 'react';
import Footers from '../Footers/Footer'
import { Container, Card, Button } from 'react-bootstrap';
import { Link, Redirect } from "react-router-dom";
import Headers from '../Headers/Headers';
import DOMPurify from 'dompurify';
//import Parser from 'html-react-parser';

// SECURITY FIX: Safe HTML content renderer without dangerouslySetInnerHTML
const SafeHtmlRenderer = ({ content }) => {
    // Check if content contains HTML tags
    const hasHtmlTags = /<[^>]*>/g.test(content);
    
    if (!hasHtmlTags) {
        // Plain text content - render safely
        return <span>{content}</span>;
    }
    
    // For HTML content, parse and render safely without dangerouslySetInnerHTML
    // This approach converts HTML to React elements safely
    const sanitizedContent = DOMPurify.sanitize(content, {
        ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'u', 'br', 'p', 'span'],
        ALLOWED_ATTR: ['class'],
        FORBID_SCRIPTS: true,
        FORBID_TAGS: ['script', 'object', 'embed', 'link', 'style', 'img', 'svg', 'iframe', 'frame'],
        KEEP_CONTENT: true
    });
    
    // Parse HTML tags and convert to React elements manually (secure approach)
    const parseHtmlToReact = (htmlString) => {
        // Simple and secure HTML parser for specific allowed tags
        const parts = [];
        let remaining = htmlString;
        let key = 0;
        
        while (remaining.length > 0) {
            // Find next HTML tag
            const tagMatch = remaining.match(/<(\/?)(b|i|em|strong|u|br|p|span)(\s[^>]*)?>([^<]*)/i);
            
            if (!tagMatch) {
                // No more tags, add remaining text
                if (remaining.trim()) {
                    parts.push(<span key={key++}>{remaining}</span>);
                }
                break;
            }
            
            const [fullMatch, isClosing, tagName, , textContent] = tagMatch;
            const beforeTag = remaining.substring(0, remaining.indexOf(fullMatch));
            
            // Add text before the tag
            if (beforeTag.trim()) {
                parts.push(<span key={key++}>{beforeTag}</span>);
            }
            
            // Add the HTML element safely
            if (!isClosing) {
                const props = { key: key++ };
                
                switch (tagName.toLowerCase()) {
                    case 'b':
                    case 'strong':
                        parts.push(<strong {...props}>{textContent}</strong>);
                        break;
                    case 'i':
                    case 'em':
                        parts.push(<em {...props}>{textContent}</em>);
                        break;
                    case 'u':
                        parts.push(<u {...props}>{textContent}</u>);
                        break;
                    case 'br':
                        parts.push(<br {...props} />);
                        break;
                    case 'p':
                        parts.push(<p {...props}>{textContent}</p>);
                        break;
                    case 'span':
                        parts.push(<span {...props}>{textContent}</span>);
                        break;
                    default:
                        // Fallback to plain text for any unrecognized tags
                        parts.push(<span {...props}>{textContent}</span>);
                }
            }
            
            // Move to the rest of the string
            remaining = remaining.substring(remaining.indexOf(fullMatch) + fullMatch.length);
        }
        
        return parts.length > 0 ? parts : [<span key={0}>{htmlString}</span>];
    };
    
    // Return parsed React elements
    return <>{parseHtmlToReact(sanitizedContent)}</>;
};

function closeHandler()  { 
    window.open('','_parent','');
    window.close();     
    }

const Result = props => {
    
    let body = 'Loading...'
    let redirectMsg = null
    const userid = localStorage.getItem('id')
    console.log(props.location.state)

    if (props.location.state) {
        if(props.location.state.userType === "Student") {       
            if(userid) {
                redirectMsg = (
                    <p>Please log out before closing the window. </p>
                )
            } else {
                redirectMsg = (
                    <p>Please close this window. </p>
                )
            }             
        } else {
            redirectMsg = (
                <p>Please refer to the <Link to={
                    {
                        pathname: "/PhotoGuide",
                        state: {
                            studentID: props.location.state.studentID,
                            userType: props.location.state.userType,
                            accesstoken: props.location.state.accesstoken,
                            staffName: props.location.state.staffName
                        }
                    }
                }>guidelines</Link> or click <Link to={
                    {
                        pathname: "/Upload",
                        state: {
                            studentID: props.location.state.studentID,
                            userType: props.location.state.userType,
                            accesstoken: props.location.state.accesstoken,
                            staffName: props.location.state.staffName
                        }
                    }
                }>here</Link> to return to upload page. </p>
            )
        }
        if (props.location.state.uploadStatus) {
            body = (
                <div className="text-center">
                    <p>Your photo has been successfully uploaded.</p>
                    <p>RP may contact you if they need you to resubmit your photo.</p>
                    {redirectMsg}
                </div>

            );
        } else {
            // let photoguidelinesreplacetext = <Link to={{pathname: "/PhotoGuide",state: {studentID: props.location.state.studentID,userType: props.location.state.userType,accesstoken: props.location.state.accesstoken,staffName: props.location.state.staffName}}}>guidelines</Link>
            // let photoguidelinereplacetext = <Link to={{pathname: "/PhotoGuide",state: {studentID: props.location.state.studentID,userType: props.location.state.userType,accesstoken: props.location.state.accesstoken,staffName: props.location.state.staffName}}}>guideline</Link>
            const uniqueRemarks = []
            props.location.state.uploadRemarks.split(',').map(rem => {
                if (uniqueRemarks.indexOf(rem) === -1) {
                    uniqueRemarks.push(rem.replace('|',','))
                }
            });
            body = (
                <div>
                    <h5>These are the possible reasons for failure:</h5>
                    <ul>    
                        {uniqueRemarks.map(element => {
                            if (element !== "Success" || element !== '') {
                                // if(element.indexOf("guidelines")!=-1)
                                // {
                                //     return <li key={element}>{element.substring(0,element.indexOf("guidelines"))} {photoguidelinesreplacetext}
                                //         {element.substring(element.indexOf("guidelines")+10,element.length )}</li>
                                // }
                                // else if(element.indexOf("guideline")!=-1)
                                // {
                                //     return <li key={element}>{element.substring(0,element.indexOf("guideline"))} {photoguidelinereplacetext}
                                //         {element.substring(element.indexOf("guideline")+9,element.length )}</li>
                                // }
                                // else
                                // {
                                    //return <div dangerouslySetInnerHTML={{__html:<li key={element}>{element}</li>}} />  
                                    //return <div>Parser(element)</div>
                                    //let htmlFromBackend = `<b>Hello there</b>, partner!`

// SECURITY FIX: Completely eliminated dangerouslySetInnerHTML - using safe React rendering
return (
  <li key={element}>
    <SafeHtmlRenderer content={element} />
  </li>
);
                            }
                        })}
                    </ul>
                    <p>Please refer to the <Link to={
                    {
                        pathname: "/PhotoGuide",
                        state: {
                            studentID: props.location.state.studentID,
                                userType: props.location.state.userType,
                                accesstoken: props.location.state.accesstoken,
                                staffName: props.location.state.staffName,
                                role: props.location.state.role
                        }
                    }
                }>guidelines</Link> or click <Link to={
                        {
                            pathname: "/Upload",
                            state: {
                                studentID: props.location.state.studentID,
                                userType: props.location.state.userType,
                                accesstoken: props.location.state.accesstoken,
                                staffName: props.location.state.staffName,
                                role: props.location.state.role
                            }
                        }
                    }>here</Link> to return to upload page. </p>
                </div>
            )
        }

        return (
            <div>
                <Headers user={userid} />
                <Container className="col-md-6">
                    <Card className="mt-5">
                        <Card.Header className="bg-brandcolor text-center">
                            <h5 className="text-white">Result</h5>
                        </Card.Header>
                        <Card.Body>
                            {body}
                        </Card.Body>
                    </Card>
                </Container>
                <Footers />
            </div>
        );
    } else {
        return (
            // <Redirect to='/' />
            <div>
                <Headers user={userid} />
                <Container className="col-md-6">
                    <Card className="mt-5">
                        <Card.Header className="bg-brandcolor text-center">
                            <h5 className="text-white">Result</h5>
                        </Card.Header>
                        <Card.Body>
                            {body}
                        </Card.Body>
                    </Card>
                </Container>
                <Footers />
            </div>
        )

    }

}

export default Result;
